// ============================================================================
// GENERIC CONFIRM MODAL - Reusable for all confirm() replacements
// ============================================================================

export function ConfirmModal({
  title,
  message,
  onConfirm,
  onClose,
  confirmText = 'Bestätigen',
  confirmClass = 'btn-primary',
  loading = false
}) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="modal-close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="modal-body">
          <p>{message}</p>
        </div>

        <div className="modal-actions">
          <button type="button" onClick={onClose} disabled={loading}>
            Abbrechen
          </button>
          <button
            type="button"
            className={confirmClass}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Lädt...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
